import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-email',
  templateUrl: './modal-email.component.html',
  styleUrl: './modal-email.component.scss',
})
export class ModalEmailComponent {
  @ViewChild('modalEmail')
  modalEmail!: ElementRef;
  emailFG!: FormGroup;
  emailForm = [
    {
      name: 'correo',
      label: 'Correo',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El correo es requerido',
        pattern: 'Solo se permiten correos válidos',
      },
    },
  ];

  @Output() correoEmitter = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const formControls: any = {};
    this.emailForm.forEach(field => {
      if (field.visible) {
        formControls[field.name] = [null, []];
      }
    });
    this.emailFG = this.fb.group(formControls);
  }

  createForm(): void {
    const formControls: any = {};
    this.emailForm.forEach(field => {
      if (field.visible) {
        const validators = [];
        if (field.required) {
          validators.push(Validators.required);
        }
        if (field.name === 'correo') {
          validators.push(
            Validators.pattern(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            )
          );
        }
        formControls[field.name] = [null, validators];
      }
    });
    this.emailFG = this.fb.group(formControls);
  }

  submitForm(): void {
    if (this.emailFG.valid) {
      this.correoEmitter.emit(this.emailFG.value);
      this.abrirCerrarModal();
      this.emailFG.reset();
    } else {
      this.emailFG.markAllAsTouched();
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.emailFG.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      if (errorType === 'pattern') {
        return (
          this.emailForm.find(f => f.name === field)?.errorMessages?.[
            errorType
          ] || 'Correo inválido'
        );
      }
      if (errorType === 'required') {
        return (
          this.emailForm.find(f => f.name === field)?.errorMessages?.[
            errorType
          ] || 'Campo requerido'
        );
      }
    }
    return null;
  }

  abrirCerrarModal() {
    this.createForm();
    this.modalEmail.nativeElement.click();
  }
}
